<div *ngIf="points">
  <agm-map [zoom]='zoom' #AgmMap [longitude]='center.lng' [latitude]='center.lat'>
    <agm-polyline AgmFitBounds>
      <agm-polyline-point [latitude]="point.lat" [longitude]="point.lng" *ngFor="let point of points">
      </agm-polyline-point>
    </agm-polyline>
  </agm-map>
</div>